import { withTheme } from '@mui/styles';
import styled from 'styled-components';

const FrameStyle = withTheme(styled.div`
  width: 285px;
  height: 75px;
  padding: 15px;
  border-radius: 20px;
  box-shadow: 7px 7px 8px 0 rgba(0, 0, 0, 0.28);
  display: flex;
  align-items: center;
  img {
    margin-right: 15px;
    width: 45px;
    opacity: 1;
  }
  p {
    line-height: 0.94;
    color: #58595b;
    font-size: 18px;
    font-weight: bold;
    opacity: 0.85;
  }
  ${(props: any) => props.theme.breakpoints.down('sm')} {
    width: 95%;
  }
`);

export default FrameStyle;
